import React, { Component } from 'react'

import { Lightbox } from '../../../../components'

class StepGuide extends Component {
  constructor(props) {
    super(props)
    this.scrollRef = React.createRef()

    this.state = {
      visible: this.props.visible,
      active: 1,
      offset: 15,
      sticky: false,
    }
  }

  toggle = e => {
    this.setState(prevState => {
      return { visible: !prevState.visible }
    })
    console.log(this.state.visible)
  }

  nextStep = e => {
    this.state.active < 3 &&
      this.setState(prevState => {
        return { active: prevState.active + 1 }
      })
  }

  prevStep = e => {
    this.state.active > 1 &&
      this.setState(prevState => {
        return { active: prevState.active - 1 }
      })
  }

  handleScroll = e => {
    let scrolled = e.target.scrollTop
    scrolled > 0
      ? this.setState({ sticky: true })
      : this.setState({ sticky: false })
  }

  render() {
    return (
        <div class={`p-step-guide + ${this.state.visible && 'show'}`}>
          <div
            class={`p-step-guide__close-bar + ${this.state.sticky &&
              'p-step-guide__close-bar--sticky'}`}
          >
            <h1
              class={`p-step-guide__close-bar-title ${this.state.sticky &&
                'fadeIn'}`}
            >
              Header
            </h1>
            <button
              class="p-step-guide__close-bar-button"
              onClick={this.toggle}
            >
              <i class="icon icon--x p-step-guide__close-bar-button-icon"></i>{' '}
              <span class="p-step-guide__close-bar-button-text">Close</span>
            </button>
          </div>
          <div
            class={`p-step-guide__content  + ${this.state.active === 1 &&
              'show'}`}
            onScroll={this.handleScroll}
          >
            <div class="p-step-guide__header">
              <div class="p-step-guide__eyebrow">
                Step Description: This is Step 1
              </div>
              <h1 class="p-step-guide__header-title" ref={this.scrollRef}>
                Step Title: Step 1
              </h1>
            </div>
            <p class="l-margin-bottom--medium">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas
              eget purus vel ligula euismod feugiat. Curabitur quis dolor at
              purus laoreet varius. Vestibulum sagittis orci et dictum
              condimentum. Ut quis tortor ultrices orci convallis auctor ut ut
              massa. Nunc sollicitudin ultricies tellus at ullamcorper. Praesent
              auctor dolor eu rhoncus commodo. Curabitur scelerisque cursus
              nibh, a venenatis libero elementum at. Integer vel mauris ligula.
              Proin pulvinar turpis diam, at lobortis ligula auctor nec. Vivamus
              id elit dolor. Quisque porta justo pulvinar augue maximus, eget
              luctus neque malesuada. Nunc a lacinia sem. Sed nibh augue,
              sodales eget porttitor ultrices, facilisis in velit. Maecenas
              egestas nulla vitae est commodo dignissim. Nulla sed massa
              molestie, venenatis dui sed, congue justo. Quisque auctor lacus et
              tortor venenatis viverra. In ac enim sed nulla pharetra suscipit
              eget et mi. Duis ac mollis sem. Duis elementum ex sit amet ligula
              vehicula, vitae malesuada justo congue. Donec ac nisi dignissim,
              tincidunt nibh id, fringilla ligula. Nulla et tellus porta lectus
              fringilla hendrerit. Nulla consequat aliquam efficitur.
              Suspendisse non odio non dui tincidunt volutpat. Morbi congue
              pharetra ornare. Nulla eu turpis non mi porta eleifend. Nam et
              elementum mauris. Maecenas eget vehicula tellus. Curabitur quam
              tellus, pulvinar ac suscipit blandit, tincidunt eget ligula. Ut
              sit amet orci id felis vehicula interdum eget suscipit ipsum.
              Maecenas eget interdum urna, eu ornare tortor. Pellentesque
              blandit mauris at augue dignissim ullamcorper. Sed imperdiet diam
              mauris, eu sagittis diam fermentum nec. Donec hendrerit mi non
              placerat sollicitudin. Proin eu dolor eu sapien eleifend hendrerit
              eu id mi. Etiam sed interdum eros. Suspendisse feugiat odio non
              aliquam lacinia. Curabitur sit amet eros ac augue aliquam porta.
              Cras at condimentum ante. Curabitur efficitur eget massa non
              elementum. Aenean blandit, lacus at convallis suscipit, urna elit
              sollicitudin arcu, vel facilisis diam orci a quam. Aliquam mi
              velit, pharetra ut malesuada eu, convallis eget ex. Aenean ut
              tincidunt felis. Nulla facilisi. Cras laoreet quam nulla, at
              vestibulum metus tristique sit amet. Praesent non ipsum vitae enim
              consequat blandit. Pellentesque habitant morbi tristique senectus
              et netus et malesuada fames ac turpis egestas. Integer convallis
              volutpat turpis, a consectetur mi commodo non. Nam quis dolor
              cursus augue aliquet tempor. Vivamus a mi fermentum ex consequat
              tristique. Integer risus lectus, egestas id est vel, sagittis
              ullamcorper leo. Aenean sed ligula et sapien vulputate vulputate.
              Phasellus sed ante scelerisque ipsum tincidunt volutpat. Sed
              aliquam molestie elementum. Morbi venenatis varius lorem accumsan
              vehicula. Curabitur id enim et mauris pellentesque scelerisque.
              Suspendisse luctus convallis nisi vel iaculis. Maecenas egestas
              leo sed magna mollis, at tincidunt dui faucibus. Nullam vitae
              lorem feugiat, luctus elit ac, auctor libero. Donec elementum
              ullamcorper velit, at facilisis ipsum. Curabitur semper sagittis
              diam, non mattis massa molestie eget. Quisque mollis viverra
              dapibus. Nunc ultrices leo et arcu gravida, sed consequat dui
              aliquet. Morbi interdum est id ligula ornare, at posuere tellus
              pulvinar. Pellentesque a ligula placerat, vestibulum leo eu,
              consectetur eros. Nulla vitae nunc sit amet ante hendrerit
              interdum. Sed mattis iaculis bibendum. Integer viverra felis sed
              erat mattis, sed dignissim lectus pellentesque.
            </p>
            <p class="l-margin-bottom--medium">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas
              eget purus vel ligula euismod feugiat. Curabitur quis dolor at
              purus laoreet varius. Vestibulum sagittis orci et dictum
              condimentum. Ut quis tortor ultrices orci convallis auctor ut ut
              massa. Nunc sollicitudin ultricies tellus at ullamcorper. Praesent
              auctor dolor eu rhoncus commodo. Curabitur scelerisque cursus
              nibh, a venenatis libero elementum at. Integer vel mauris ligula.
              Proin pulvinar turpis diam, at lobortis ligula auctor nec. Vivamus
              id elit dolor. Quisque porta justo pulvinar augue maximus, eget
              luctus neque malesuada. Nunc a lacinia sem. Sed nibh augue,
              sodales eget porttitor ultrices, facilisis in velit. Maecenas
              egestas nulla vitae est commodo dignissim. Nulla sed massa
              molestie, venenatis dui sed, congue justo. Quisque auctor lacus et
              tortor venenatis viverra. In ac enim sed nulla pharetra suscipit
              eget et mi. Duis ac mollis sem. Duis elementum ex sit amet ligula
              vehicula, vitae malesuada justo congue. Donec ac nisi dignissim,
              tincidunt nibh id, fringilla ligula. Nulla et tellus porta lectus
              fringilla hendrerit. Nulla consequat aliquam efficitur.
              Suspendisse non odio non dui tincidunt volutpat. Morbi congue
              pharetra ornare. Nulla eu turpis non mi porta eleifend. Nam et
              elementum mauris. Maecenas eget vehicula tellus. Curabitur quam
              tellus, pulvinar ac suscipit blandit, tincidunt eget ligula. Ut
              sit amet orci id felis vehicula interdum eget suscipit ipsum.
              Maecenas eget interdum urna, eu ornare tortor. Pellentesque
              blandit mauris at augue dignissim ullamcorper. Sed imperdiet diam
              mauris, eu sagittis diam fermentum nec. Donec hendrerit mi non
              placerat sollicitudin. Proin eu dolor eu sapien eleifend hendrerit
              eu id mi. Etiam sed interdum eros. Suspendisse feugiat odio non
              aliquam lacinia. Curabitur sit amet eros ac augue aliquam porta.
              Cras at condimentum ante. Curabitur efficitur eget massa non
              elementum. Aenean blandit, lacus at convallis suscipit, urna elit
              sollicitudin arcu, vel facilisis diam orci a quam. Aliquam mi
              velit, pharetra ut malesuada eu, convallis eget ex. Aenean ut
              tincidunt felis. Nulla facilisi. Cras laoreet quam nulla, at
              vestibulum metus tristique sit amet. Praesent non ipsum vitae enim
              consequat blandit. Pellentesque habitant morbi tristique senectus
              et netus et malesuada fames ac turpis egestas. Integer convallis
              volutpat turpis, a consectetur mi commodo non. Nam quis dolor
              cursus augue aliquet tempor. Vivamus a mi fermentum ex consequat
              tristique. Integer risus lectus, egestas id est vel, sagittis
              ullamcorper leo. Aenean sed ligula et sapien vulputate vulputate.
              Phasellus sed ante scelerisque ipsum tincidunt volutpat. Sed
              aliquam molestie elementum. Morbi venenatis varius lorem accumsan
              vehicula. Curabitur id enim et mauris pellentesque scelerisque.
              Suspendisse luctus convallis nisi vel iaculis. Maecenas egestas
              leo sed magna mollis, at tincidunt dui faucibus. Nullam vitae
              lorem feugiat, luctus elit ac, auctor libero. Donec elementum
              ullamcorper velit, at facilisis ipsum. Curabitur semper sagittis
              diam, non mattis massa molestie eget. Quisque mollis viverra
              dapibus. Nunc ultrices leo et arcu gravida, sed consequat dui
              aliquet. Morbi interdum est id ligula ornare, at posuere tellus
              pulvinar. Pellentesque a ligula placerat, vestibulum leo eu,
              consectetur eros. Nulla vitae nunc sit amet ante hendrerit
              interdum. Sed mattis iaculis bibendum. Integer viverra felis sed
              erat mattis, sed dignissim lectus pellentesque.
            </p>
            <p class="l-margin-bottom--medium">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas
              eget purus vel ligula euismod feugiat. Curabitur quis dolor at
              purus laoreet varius. Vestibulum sagittis orci et dictum
              condimentum. Ut quis tortor ultrices orci convallis auctor ut ut
              massa. Nunc sollicitudin ultricies tellus at ullamcorper. Praesent
              auctor dolor eu rhoncus commodo. Curabitur scelerisque cursus
              nibh, a venenatis libero elementum at. Integer vel mauris ligula.
              Proin pulvinar turpis diam, at lobortis ligula auctor nec. Vivamus
              id elit dolor. Quisque porta justo pulvinar augue maximus, eget
              luctus neque malesuada. Nunc a lacinia sem. Sed nibh augue,
              sodales eget porttitor ultrices, facilisis in velit. Maecenas
              egestas nulla vitae est commodo dignissim. Nulla sed massa
              molestie, venenatis dui sed, congue justo. Quisque auctor lacus et
              tortor venenatis viverra. In ac enim sed nulla pharetra suscipit
              eget et mi. Duis ac mollis sem. Duis elementum ex sit amet ligula
              vehicula, vitae malesuada justo congue. Donec ac nisi dignissim,
              tincidunt nibh id, fringilla ligula. Nulla et tellus porta lectus
              fringilla hendrerit. Nulla consequat aliquam efficitur.
              Suspendisse non odio non dui tincidunt volutpat. Morbi congue
              pharetra ornare. Nulla eu turpis non mi porta eleifend. Nam et
              elementum mauris. Maecenas eget vehicula tellus. Curabitur quam
              tellus, pulvinar ac suscipit blandit, tincidunt eget ligula. Ut
              sit amet orci id felis vehicula interdum eget suscipit ipsum.
              Maecenas eget interdum urna, eu ornare tortor. Pellentesque
              blandit mauris at augue dignissim ullamcorper. Sed imperdiet diam
              mauris, eu sagittis diam fermentum nec. Donec hendrerit mi non
              placerat sollicitudin. Proin eu dolor eu sapien eleifend hendrerit
              eu id mi. Etiam sed interdum eros. Suspendisse feugiat odio non
              aliquam lacinia. Curabitur sit amet eros ac augue aliquam porta.
              Cras at condimentum ante. Curabitur efficitur eget massa non
              elementum. Aenean blandit, lacus at convallis suscipit, urna elit
              sollicitudin arcu, vel facilisis diam orci a quam. Aliquam mi
              velit, pharetra ut malesuada eu, convallis eget ex. Aenean ut
              tincidunt felis. Nulla facilisi. Cras laoreet quam nulla, at
              vestibulum metus tristique sit amet. Praesent non ipsum vitae enim
              consequat blandit. Pellentesque habitant morbi tristique senectus
              et netus et malesuada fames ac turpis egestas. Integer convallis
              volutpat turpis, a consectetur mi commodo non. Nam quis dolor
              cursus augue aliquet tempor. Vivamus a mi fermentum ex consequat
              tristique. Integer risus lectus, egestas id est vel, sagittis
              ullamcorper leo. Aenean sed ligula et sapien vulputate vulputate.
              Phasellus sed ante scelerisque ipsum tincidunt volutpat. Sed
              aliquam molestie elementum. Morbi venenatis varius lorem accumsan
              vehicula. Curabitur id enim et mauris pellentesque scelerisque.
              Suspendisse luctus convallis nisi vel iaculis. Maecenas egestas
              leo sed magna mollis, at tincidunt dui faucibus. Nullam vitae
              lorem feugiat, luctus elit ac, auctor libero. Donec elementum
              ullamcorper velit, at facilisis ipsum. Curabitur semper sagittis
              diam, non mattis massa molestie eget. Quisque mollis viverra
              dapibus. Nunc ultrices leo et arcu gravida, sed consequat dui
              aliquet. Morbi interdum est id ligula ornare, at posuere tellus
              pulvinar. Pellentesque a ligula placerat, vestibulum leo eu,
              consectetur eros. Nulla vitae nunc sit amet ante hendrerit
              interdum. Sed mattis iaculis bibendum. Integer viverra felis sed
              erat mattis, sed dignissim lectus pellentesque.
            </p>
            <hr class="c-divider l-margin-vertical--large" />
          </div>
          <div
            class={`p-step-guide__content  + ${this.state.active === 2 &&
              'show'}`}
            onScroll={this.handleScroll}
          >
            <div class="p-step-guide__header">
              <div class="p-step-guide__eyebrow">
                Step Description: This is Step 2
              </div>
              <h1 class="p-step-guide__header-title">Step Title: Step 2</h1>
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas
              eget purus vel ligula euismod feugiat. Curabitur quis dolor at
              purus laoreet varius. Vestibulum sagittis orci et dictum
              condimentum. Ut quis tortor ultrices orci convallis auctor ut ut
              massa. Nunc sollicitudin ultricies tellus at ullamcorper. Praesent
              auctor dolor eu rhoncus commodo. Curabitur scelerisque cursus
              nibh, a venenatis libero elementum at. Integer vel mauris ligula.
              Proin pulvinar turpis diam, at lobortis ligula auctor nec. Vivamus
              id elit dolor. Quisque porta justo pulvinar augue maximus, eget
              luctus neque malesuada. Nunc a lacinia sem. Sed nibh augue,
              sodales eget porttitor ultrices, facilisis in velit. Maecenas
              egestas nulla vitae est commodo dignissim. Nulla sed massa
              molestie, venenatis dui sed, congue justo. Quisque auctor lacus et
              tortor venenatis viverra. In ac enim sed nulla pharetra suscipit
              eget et mi. Duis ac mollis sem. Duis elementum ex sit amet ligula
              vehicula, vitae malesuada justo congue. Donec ac nisi dignissim,
              tincidunt nibh id, fringilla ligula. Nulla et tellus porta lectus
              fringilla hendrerit. Nulla consequat aliquam efficitur.
              Suspendisse non odio non dui tincidunt volutpat. Morbi congue
              pharetra ornare. Nulla eu turpis non mi porta eleifend. Nam et
              elementum mauris. Maecenas eget vehicula tellus. Curabitur quam
              tellus, pulvinar ac suscipit blandit, tincidunt eget ligula. Ut
              sit amet orci id felis vehicula interdum eget suscipit ipsum.
              Maecenas eget interdum urna, eu ornare tortor. Pellentesque
              blandit mauris at augue dignissim ullamcorper. Sed imperdiet diam
              mauris, eu sagittis diam fermentum nec. Donec hendrerit mi non
              placerat sollicitudin. Proin eu dolor eu sapien eleifend hendrerit
              eu id mi. Etiam sed interdum eros. Suspendisse feugiat odio non
              aliquam lacinia. Curabitur sit amet eros ac augue aliquam porta.
              Cras at condimentum ante. Curabitur efficitur eget massa non
              elementum. Aenean blandit, lacus at convallis suscipit, urna elit
              sollicitudin arcu, vel facilisis diam orci a quam. Aliquam mi
              velit, pharetra ut malesuada eu, convallis eget ex. Aenean ut
              tincidunt felis. Nulla facilisi. Cras laoreet quam nulla, at
              vestibulum metus tristique sit amet. Praesent non ipsum vitae enim
              consequat blandit. Pellentesque habitant morbi tristique senectus
              et netus et malesuada fames ac turpis egestas. Integer convallis
              volutpat turpis, a consectetur mi commodo non. Nam quis dolor
              cursus augue aliquet tempor. Vivamus a mi fermentum ex consequat
              tristique. Integer risus lectus, egestas id est vel, sagittis
              ullamcorper leo. Aenean sed ligula et sapien vulputate vulputate.
              Phasellus sed ante scelerisque ipsum tincidunt volutpat. Sed
              aliquam molestie elementum. Morbi venenatis varius lorem accumsan
              vehicula. Curabitur id enim et mauris pellentesque scelerisque.
              Suspendisse luctus convallis nisi vel iaculis. Maecenas egestas
              leo sed magna mollis, at tincidunt dui faucibus. Nullam vitae
              lorem feugiat, luctus elit ac, auctor libero. Donec elementum
              ullamcorper velit, at facilisis ipsum. Curabitur semper sagittis
              diam, non mattis massa molestie eget. Quisque mollis viverra
              dapibus. Nunc ultrices leo et arcu gravida, sed consequat dui
              aliquet. Morbi interdum est id ligula ornare, at posuere tellus
              pulvinar. Pellentesque a ligula placerat, vestibulum leo eu,
              consectetur eros. Nulla vitae nunc sit amet ante hendrerit
              interdum. Sed mattis iaculis bibendum. Integer viverra felis sed
              erat mattis, sed dignissim lectus pellentesque.
            </p>
            <hr class="c-divider l-margin-vertical--large" />
          </div>
          <div
            class={`p-step-guide__content  + ${this.state.active === 3 &&
              'show'}`}
            onScroll={this.handleScroll}
          >
            <div class="p-step-guide__header">
              <div class="p-step-guide__eyebrow">
                Step Description: This is Step 3
              </div>
              <h1 class="p-step-guide__header-title">Step Title: Step 3</h1>
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas
              eget purus vel ligula euismod feugiat. Curabitur quis dolor at
              purus laoreet varius. Vestibulum sagittis orci et dictum
              condimentum. Ut quis tortor ultrices orci convallis auctor ut ut
              massa. Nunc sollicitudin ultricies tellus at ullamcorper. Praesent
              auctor dolor eu rhoncus commodo. Curabitur scelerisque cursus
              nibh, a venenatis libero elementum at. Integer vel mauris ligula.
              Proin pulvinar turpis diam, at lobortis ligula auctor nec. Vivamus
              id elit dolor. Quisque porta justo pulvinar augue maximus, eget
              luctus neque malesuada. Nunc a lacinia sem. Sed nibh augue,
              sodales eget porttitor ultrices, facilisis in velit. Maecenas
              egestas nulla vitae est commodo dignissim. Nulla sed massa
              molestie, venenatis dui sed, congue justo. Quisque auctor lacus et
              tortor venenatis viverra. In ac enim sed nulla pharetra suscipit
              eget et mi. Duis ac mollis sem. Duis elementum ex sit amet ligula
              vehicula, vitae malesuada justo congue. Donec ac nisi dignissim,
              tincidunt nibh id, fringilla ligula. Nulla et tellus porta lectus
              fringilla hendrerit. Nulla consequat aliquam efficitur.
              Suspendisse non odio non dui tincidunt volutpat. Morbi congue
              pharetra ornare. Nulla eu turpis non mi porta eleifend. Nam et
              elementum mauris. Maecenas eget vehicula tellus. Curabitur quam
              tellus, pulvinar ac suscipit blandit, tincidunt eget ligula. Ut
              sit amet orci id felis vehicula interdum eget suscipit ipsum.
              Maecenas eget interdum urna, eu ornare tortor. Pellentesque
              blandit mauris at augue dignissim ullamcorper. Sed imperdiet diam
              mauris, eu sagittis diam fermentum nec. Donec hendrerit mi non
              placerat sollicitudin. Proin eu dolor eu sapien eleifend hendrerit
              eu id mi. Etiam sed interdum eros. Suspendisse feugiat odio non
              aliquam lacinia. Curabitur sit amet eros ac augue aliquam porta.
              Cras at condimentum ante. Curabitur efficitur eget massa non
              elementum. Aenean blandit, lacus at convallis suscipit, urna elit
              sollicitudin arcu, vel facilisis diam orci a quam. Aliquam mi
              velit, pharetra ut malesuada eu, convallis eget ex. Aenean ut
              tincidunt felis. Nulla facilisi. Cras laoreet quam nulla, at
              vestibulum metus tristique sit amet. Praesent non ipsum vitae enim
              consequat blandit. Pellentesque habitant morbi tristique senectus
              et netus et malesuada fames ac turpis egestas. Integer convallis
              volutpat turpis, a consectetur mi commodo non. Nam quis dolor
              cursus augue aliquet tempor. Vivamus a mi fermentum ex consequat
              tristique. Integer risus lectus, egestas id est vel, sagittis
              ullamcorper leo. Aenean sed ligula et sapien vulputate vulputate.
              Phasellus sed ante scelerisque ipsum tincidunt volutpat. Sed
              aliquam molestie elementum. Morbi venenatis varius lorem accumsan
              vehicula. Curabitur id enim et mauris pellentesque scelerisque.
              Suspendisse luctus convallis nisi vel iaculis. Maecenas egestas
              leo sed magna mollis, at tincidunt dui faucibus. Nullam vitae
              lorem feugiat, luctus elit ac, auctor libero. Donec elementum
              ullamcorper velit, at facilisis ipsum. Curabitur semper sagittis
              diam, non mattis massa molestie eget. Quisque mollis viverra
              dapibus. Nunc ultrices leo et arcu gravida, sed consequat dui
              aliquet. Morbi interdum est id ligula ornare, at posuere tellus
              pulvinar. Pellentesque a ligula placerat, vestibulum leo eu,
              consectetur eros. Nulla vitae nunc sit amet ante hendrerit
              interdum. Sed mattis iaculis bibendum. Integer viverra felis sed
              erat mattis, sed dignissim lectus pellentesque.
            </p>
            <hr class="c-divider l-margin-vertical--large" />
          </div>
          <div class="p-step-guide__footer">
            <div class="c-progress-bar--step-guide">
              <progress
                id="progress"
                value={this.state.active}
                max="3"
              ></progress>
            </div>
            <div class="p-step-guide__footer--left">
              <button
                id="prevBtn"
                class="p-step-guide__footer--left-button icon icon--arrow-with-tail-left p-step-guide__footer--left-button-icon"
                onClick={this.prevStep}
              >
                <span class="p-step-guide__footer--left-button-text">Back</span>
              </button>
              <span class="p-step-guide__footer-vertical-border"></span>
              <div class="p-step-guide__pagination">
                <span class="p-step-guide__pagination--first-number">
                  {this.state.active}
                </span>{' '}
                of <span class="p-step-guide__pagination--last-number">3</span>
              </div>
            </div>
            <div class="p-step-guide__footer--right">
              <button
                id="nextBtn"
                onClick={this.nextStep}
                class="p-step-guide__button--primary"
              >
                Next
              </button>
            </div>
          </div>
        </div>
    )
  }
}

export default StepGuide
